import React from "react";
import { friendlyPrice, friendlyNumber } from "../../../utils/calculators";
import { Row, Col, Affix, Button } from "antd";
import DetailedCostBreakdown from "./detailedCostBreakdown";

import { Container } from "../../layouts/containers";
import styles from "./summary.module.less";

const SummaryFooter = props => {
    const { inbound, outbound, buttonText, onButtonClick, subTotal, dueToday, loading } = props;

    return (
        <Affix offsetBottom={0}>
            <div
                style={{
                    minHeight: "96px",
                    backgroundColor: "white",
                    boxShadow: "0 -3px 6px 0 rgba(41,70,97,.1)",
                }}
            >
                <Container>
                    <Row
                        type="flex"
                        justify="space-around"
                        align="middle"
                        gutter={{ xs: 8, sm: 16, md: 24 }}
                        style={{ height: "100%", padding: "16px" }}
                    >
                        <Col xs={{ span: 0 }} lg={{ span: 12 }} style={{ marginBottom: "12px" }}>
                            <ul style={{ textAlign: "left", margin: "0", padding: "0" }}>
                                {outbound && (
                                    <li style={{ listStyleType: "none" }}>
                                        <a
                                            href="#/"
                                            style={{
                                                minWidth: "8rem",
                                                display: "inline-block",
                                            }}
                                        >{`Outbound Plan`}</a>
                                        <b>
                                            {`${outbound.planName} - ${friendlyNumber(
                                                outbound.includedEmails
                                            )} included emails`}
                                        </b>
                                    </li>
                                )}

                                {inbound && (
                                    <li style={{ listStyleType: "none" }} className={styles.centerIfAlone}>
                                        <a
                                            href="#/"
                                            style={{
                                                minWidth: "8rem",
                                                display: "inline-block",
                                            }}
                                        >{`Inbound Plan`}</a>
                                        <b>{`${inbound.domains} domains`}</b>
                                    </li>
                                )}

                            </ul>
                        </Col>
                        <Col xs={24} lg={8} style={{ textAlign: "right" }}>
                            <h4>{`${outbound ? `Estimated Cost` : `Total Cost`}: ${friendlyPrice(
                                subTotal
                            )}`}</h4>
                            <DetailedCostBreakdown
                                inbound={inbound}
                                outbound={outbound}
                                total={subTotal}
                                dueToday={dueToday}
                            />
                            <h6>{`*Tax may apply`}</h6>
                        </Col>
                        <Col xs={24} lg={4} style={{ textAlign: "center" }}>
                            <Button
                                type="primary"
                                size="large"
                                onClick={onButtonClick}
                                loading={loading ? true : false}
                                block
                            >
                                {buttonText}
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </div>
        </Affix>
    );
};

export default SummaryFooter;
